import React from 'react';
import { Price } from '../components/main/motorcycles/MotorcycleView';
import { getCulture } from './helpers';
import { store } from '../redux/store';
import { getPriceAvailability } from '../redux/selectors';

export default class Formatter extends React.Component {

	static currency(price: Price) {
		const pricesAreAvailable = getPriceAvailability(store.getState());
		if (!price || !pricesAreAvailable) return null;
		const formattedNumber = price.CurrencySymbol + ' ' + price.Value.toLocaleString(navigator.language, { minimumFractionDigits: 2 });
		return formattedNumber;
	}

	static toDateLocaleString(timeStamp: number) {
		const options = { date: 'number', year: 'numeric', month: 'numeric', day: 'numeric' };
		return new Date(timeStamp).toLocaleDateString(getCulture(), options);
	}
}
